module.exports = __webpack_public_path__ + "so.6f144ebdee046b0b8f84.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/so.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/so.svg
// module chunks = styles